// ////////////////////////////////////////////////////////////////////////////////////////////////////
// Purpose: A wrapper for indexedDB
// Author: Brandon Lange
// Date: 2019/03/19
// ////////////////////////////////////////////////////////////////////////////////////////////////////

class DatabaseHandler {
    constructor() {
        let self = this;
        self.request = null;
        self.db = null;
    }

    init(databaseName, databaseVersion) {
        return new Promise((resolve, reject) => {
            self.request = window.indexedDB.open(databaseName, databaseVersion);

            self.request.onerror = function (evt) {
                reject(evt);
            }

            self.request.onsuccess = function (evt) {
                self.db = evt.target.result
                


            }

            self.request.onupgradeneeded = function (evt) {
                self.db = evt.target.result
                // Configure Schema
                let inspectionTX = self.db.createObjectStore('InspectionTX', {
                    keyPath: "ID",
                    autoIncrement: true
                })

                inspectionTX.createIndex("SupervisorAllocatedInspectionID", "SupervisorAllocatedInspectionID", {
                    unique: false
                });

                inspectionTX.transaction.oncomplete = function () {

                };
                
                let userData = self.db.createObjectStore('UserData', {
                    keyPath: "ID",
                    autoIncrement: true
                });

                userData.createIndex("UserID", "UserID", {
                    unique: false
                });

                userData.transaction.oncomplete = function () {

                };

                let allocatedInspections = self.db.createObjectStore('AllocatedInspections', {
                    keyPath: "UID",
                    autoIncrement: true
                });

                allocatedInspections.createIndex("UID", "UID", {
                    unique: true
                });

                allocatedInspections.transaction.oncomplete = function () {

                };
            };
        });
    }

    getAll(table) {
        return new Promise((resolve, reject) => {
            try {
                let objectStore = self.db.transaction(table, "readwrite").objectStore(table);
                let request = objectStore.getAll();

                request.onerror = function (e) {
                    reject(e);
                }

                request.onsuccess = function (event) {
                    resolve(event.target.result);
                }
            } catch (exc) {
                reject(exc);
            }
        })
    }

    getByIndex(table, index, identifier) {
        return new Promise((resolve, reject) => {
            try {
                let objectStore = self.db.transaction(table, "readwrite").objectStore(table);
                var myIndex = objectStore.index(index);
                let request = myIndex.get(identifier);

                request.onerror = function (evt) {
                    reject(evt);
                }

                request.onsuccess = function (event) {
                    resolve(event.target.result);
                }
            } catch (exc) {
                reject();
            }
        })
    }
    getSingle(table, identifier) {
        return new Promise((resolve, reject) => {
            try {
                let objectStore = self.db.transaction(table, "readwrite").objectStore(table);
                let request = objectStore.get(identifier);

                request.onerror = function (evt) {
                    reject(evt);
                }

                request.onsuccess = function (event) {
                    resolve(event.target.result);
                }
            } catch (exc) {
                reject();
            }
        })
    }

    add(table, item) {
        return new Promise((resolve, reject) => {
            try {
                let objectStore = self.db.transaction(table, "readwrite").objectStore(table);
                let request = objectStore.add(item);

                request.onerror = function () {
                    reject();
                }

                request.onsuccess = function (event) {
                    resolve(event.target.result);
                }
            } catch (exc) {
                reject();
            }
        })
    }

    modify(table, identifier, item) {
        return new Promise((resolve, reject) => {
            try {
                let objectStore = self.db.transaction(table, "readwrite").objectStore(table);
                let request = objectStore.get(identifier);

                request.onerror = function (evt) {
                    reject(evt);
                }

                request.onsuccess = function (evt) {
                    var data = event.target.result;

                    for (let prop in data) {
                        data[prop] = item[prop];
                    }

                    let requestUpdate = objectStore.put(data);

                    requestUpdate.onerror = function (event) {
                        reject(event);
                    }

                    requestUpdate.onsuccess = function () {
                        resolve(evt);
                    }
                }
            } catch (exc) {
                reject(exc);
            }
        })
    }

    delete(table, identifier) {
        return new Promise((resolve, reject) => {
            try {
                let objectStore = self.db.transaction(table, "readwrite").objectStore(table);
                let request = objectStore.delete(identifier);

                request.onerror = function (evt) {
                    reject(evt);
                }

                request.onsuccess = function (event) {
                    resolve(event.target.result);
                }
            } catch (exc) {
                reject(exc);
            }
        })
    }

    deleteByIndex(table, index, identifier) {
        return new Promise((resolve, reject) => {
            try {
                let objectStore = self.db.transaction(table, "readwrite").objectStore(table);
                var myIndex = objectStore.index(index);
                let request = myIndex.delete(identifier);

                request.onerror = function (evt) {
                    reject(evt);
                }

                request.onsuccess = function (event) {
                    resolve(event.target.result);
                }
            } catch (exc) {
                reject();
            }
        })
    }
}

export default DatabaseHandler;